import apiClient from 'api/apiClient';

const BASE = process.env.REACT_APP_USER_REST_API_BASE_URL
  ? `${process.env.REACT_APP_USER_REST_API_BASE_URL}/api/v4/admin`
  : 'http://localhost:8080/api/v4/admin';

export interface TrialRecord {
  subscriptionId: number;
  userId: number;
  userEmail: string;
  userName: string;
  state: 'free' | 'trialing' | 'premium' | 'expired' | 'cancelled' | 'needs_attention';
  tier: 'free' | 'plus' | 'family' | 'business';
  plan: 'monthly' | 'annual' | null;
  trialEndDate: string | null;
  renewalDate: string | null;
  managingPlatform: 'apple' | 'google' | 'web' | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export interface TrialPage {
  content: TrialRecord[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export interface GrantTrialRequest {
  tier: string;
  durationDays?: number;
  endDate?: string;
  reason: string;
}

export interface UpdateTrialRequest {
  newEndDate?: string;
  reason: string;
}

export const listTrials = (
  page: number,
  size: number,
  state?: string,
  endingSoonDays?: number,
) =>
  apiClient.get<TrialPage>(`${BASE}/trials`, {
    params: {
      page,
      size,
      ...(state ? { state } : {}),
      ...(endingSoonDays != null ? { endingSoonDays } : {}),
    },
  });

export const getTrial = (email: string) =>
  apiClient.get<TrialRecord>(`${BASE}/trials/${encodeURIComponent(email)}`);

export const grantTrial = (email: string, body: GrantTrialRequest) =>
  apiClient.post<TrialRecord>(
    `${BASE}/trials/${encodeURIComponent(email)}/grant`,
    body,
  );

export const extendTrial = (email: string, body: UpdateTrialRequest) =>
  apiClient.put<TrialRecord>(
    `${BASE}/trials/${encodeURIComponent(email)}/extend`,
    body,
  );

export const endTrial = (email: string, body: UpdateTrialRequest) =>
  apiClient.put<TrialRecord>(
    `${BASE}/trials/${encodeURIComponent(email)}/end`,
    body,
  );
